<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="25" height="22.222"><path d="M9.722 0H4.167v18.056h5.555V0zM2.778 1.389H0v20.833h25V1.389H11.111v18.055H2.778V1.389zm11.111 2.778h8.333v4.166h-8.333zm2.778 6.944v2.778h-2.778v-2.778zm2.778 0h2.778v2.778h-2.779zm2.778 5.556v2.778h-2.779v-2.778zm-8.333 0h2.778v2.778h-2.779z"/></svg>
</template>

<script>
	export default {
		name: "Telephone"
	}
</script>